import React from 'react'
import { useGameStore } from '../../state/gameStore'

const formatValue = (value: number): string => {
  if (!Number.isFinite(value)) {
    return '--'
  }
  return value.toFixed(2)
}

const BnBGlobalStats: React.FC = () => {
  const { nodes, incumbentNodeId } = useGameStore((state) => state.ui.bnbState)

  const stats = React.useMemo(() => {
    let upperBound = Number.NEGATIVE_INFINITY
    let openCount = 0

    nodes.forEach((node) => {
      if (node.status === 'open' && Number.isFinite(node.lp?.optimalValue)) {
        upperBound = Math.max(upperBound, node.lp.optimalValue)
        openCount += 1
      }
    })

    let lowerBound = Number.NEGATIVE_INFINITY
    if (incumbentNodeId) {
      const incumbent = nodes.get(incumbentNodeId)
      if (incumbent && Number.isFinite(incumbent.lp?.optimalValue)) {
        lowerBound = incumbent.lp.optimalValue
      }
    }

    if (openCount === 0 && Number.isFinite(lowerBound)) {
      upperBound = lowerBound
    }

    const optimal =
      openCount === 0 ||
      (Number.isFinite(lowerBound) && Number.isFinite(upperBound) && Math.abs(upperBound - lowerBound) < 1e-6)

    return {
      lowerBound,
      upperBound,
      openCount,
      optimal,
    }
  }, [nodes, incumbentNodeId])

  return (
    <div className="grid grid-cols-4 gap-2 p-2 border-b border-white/10 bg-black/20">
      <div className="rounded bg-slate-900/70 border border-white/10 px-2 py-1">
        <div className="text-[10px] text-slate-400 uppercase tracking-wide">LB</div>
        <div className="text-sm font-mono text-emerald-300">{formatValue(stats.lowerBound)}</div>
      </div>
      <div className="rounded bg-slate-900/70 border border-white/10 px-2 py-1">
        <div className="text-[10px] text-slate-400 uppercase tracking-wide">UB</div>
        <div className="text-sm font-mono text-sky-300">{formatValue(stats.upperBound)}</div>
      </div>
      <div className="rounded bg-slate-900/70 border border-white/10 px-2 py-1">
        <div className="text-[10px] text-slate-400 uppercase tracking-wide">Open</div>
        <div className="text-sm font-mono text-white">{stats.openCount}</div>
      </div>
      <div className="rounded bg-slate-900/70 border border-white/10 px-2 py-1">
        <div className="text-[10px] text-slate-400 uppercase tracking-wide">Status</div>
        <div className={`text-sm font-semibold ${stats.optimal ? 'text-emerald-300' : 'text-amber-300'}`}>
          {stats.optimal ? 'Optimal' : 'Active'}
        </div>
      </div>
    </div>
  )
}

export default BnBGlobalStats
